import { MessageDao, RoomDao } from '@raysee/dao';
import { useMessages } from '@raysee/hooks';
import { Message } from '@raysee/schema';
import { useAsyncCallback } from 'react-async-hook';

export const useCancelMessage = (roomId: string) => {
  const [messages] = useMessages(roomId);
  return useAsyncCallback((message: Message) =>
    MessageDao(roomId)
      .delete(message.id)
      .then(() => {
        const lastMessage =
          messages.findIndex((m) => m.id === message.id) === messages.length - 1
            ? messages[messages.length - 2]
            : messages[messages.length - 1];
        return RoomDao()
          .docRef(roomId)
          .update({
            messagesCount: messages.length - 1,
            latestMessage: lastMessage.text,
          });
      }),
  );
};
